import { z } from "zod";

// Using a regex that allows all printable Unicode characters
const allowedCharactersRegexDisplayName = /^[\p{L}\p{N}\p{P}\p{Z}\p{S}]+$/u;

export const displayNameValidation = z
  .string({
    error: (issue) => (issue.input === undefined ? "Bitte gebe einen Namen ein. Es muss nicht dein echter sein." : ""),
  })
  .min(1, {
    message: "Bitte gebe einen Namen ein. Es muss nicht dein echter sein.",
  })
  .max(50, { message: "Der Name darf nicht länger als 50 Zeichen lang sein." })
  .regex(allowedCharactersRegexDisplayName, {
    message: "Der Name enthält nicht erlaubte Symbole",
  });

export const emailValidation = z.email({
  message: "Bitte gib deine beste Mailadresse an.",
});

export const passwordValidation = z
  .string({
    error: (issue) => (issue.input === undefined ? "Bitte gebe ein Passwort ein." : ""),
  })
  .min(8, { message: "Es muss mindestens 8 Zeichen lang sein." })
  .regex(/[0-9]/, {
    message: "Das Passwort muss mindestens eine Zahl enthalten.",
  })
  .regex(/[^a-zA-Z0-9]/, {
    message: "Das Passwort muss mindestens ein Sonderzeichen enthalten.",
  });

export const passwordLoginValidation = z
  .string({
    error: (issue) => (issue.input === undefined ? "Bitte gebe ein Passwort ein." : ""),
  })
  .min(1, "Bitte gebe ein Passwort ein.");

export const passwordRepeatValidation = z
  .string({
    error: (issue) => (issue.input === undefined ? "Bitte wiederhole dein Passwort." : ""),
  })
  .min(1, "Bitte gebe ein Passwort ein.");
